import { useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import { useAuth } from "../components/AuthProvider.tsx";
import Application from "../models/Application.tsx";
import AdditionalDocument from "../models/AdditionalDocument.tsx";
import MenuComponent from "../components/Menu.tsx";
import DocumentComponent from "../components/Document.tsx";
import AdditionalDocumentComponent from "../components/AdditionalDocument.tsx";
import CommentComponent from "../components/Comment.tsx";

function ApplicationView() {
  const { authorization, SetAuthorization } = useAuth();

  const NewApplication = () => {
    const application: Application = {
      Token: "",
      ApplicationId: 0,
      BusinessId: 0,
      ApplicationStatusId: 1,
      FirstName: "",
      LastName: "",
      JobTitle: "",
      JobNumber: "",
      JobOfferId: null,
      Schedule1Id: null,
      LanguageTestResultId: null,
      PassportScanId: null,
      ProofOfStatusId: null,
      ProofOfWorkExperienceId: null,
      IntentToResideId: null,
      EducationCredentialId: null,
      CanadianCredentialId: null,
      AdditionalDocuments: [],
      IsComplete: false
    }
    return application;
  }

  const navigate = useNavigate();
  const { applicationId } = useParams();
  const [application, SetApplication] = useState(NewApplication());

  useEffect(() => {
    if (authorization && applicationId) {
      fetch("/api/application?token=" + authorization.Token + "&applicationId=" + applicationId)
        .then(response => response.json())
        .then(data => SetApplication(data))
        .catch(error => console.error(error));
    }
  }, [authorization]);

  const Submit = (event: React.ChangeEvent<any>) => {
    event.preventDefault();

    application.Token = authorization.Token;
    application.ApplicationId = applicationId ? Number(applicationId) : 0;
    const options = {
      method: applicationId ? "PATCH" : "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(application)
    };

    fetch("/api/application", options)
      .then(response => response.text)
      .then(data => navigate("/applications"))
      .catch(error => console.error(error));
  }

  const OnChange = (event: React.ChangeEvent<any>) => {
    const { name, value } = event.target;
    SetApplication((prevState) => ({ ...prevState, [name]: value }));
  }

  const AddAdditionalDocument = (document: AdditionalDocument) => {
    var current = application;
    current.AdditionalDocuments = [...current.AdditionalDocuments, document];
    SetApplication(current);
  }

  const DeleteAdditionalDocument = (index: number) => {
    var current = application;
    current.AdditionalDocuments.splice(index, 1);
    SetApplication(current);
  }

  return (
    <>
      <MenuComponent page={applicationId ? "Update Application" : "Create Application"} />

      <section id="main">
        <div className="container">
          <p>Please note, <strong>all fields are mandatory</strong> unless otherwise indicated in order to submit an application.</p>
          <form onSubmit={Submit}>
            {application.JobNumber && 
              <p>
                <strong>Application Number:</strong> {application.JobNumber}
                <span className="tooltip">
                  {application.ApplicationStatusId == 1 && <><img src="/images/Application-Submitted.png" alt="Submitted" /><span className="tooltiptext">Application Submitted</span></>}
                  {application.ApplicationStatusId == 2 && <><img src="/images/Application-Reviewed.png" alt="Reviewed" /><span className="tooltiptext">Application Reviewed</span></>}
                  {application.ApplicationStatusId == 3 && <><img src="/images/Application-Incomplete.png" alt="Incomplete" /><span className="tooltiptext">Application Incomplete</span></>}
                  {application.ApplicationStatusId == 4 && <><img src="/images/Application-Accepted.png" alt="Accepted" /><span className="tooltiptext">Application Accepted</span></>}
                  {application.ApplicationStatusId == 5 && <><img src="/images/Application-Declined.png" alt="Declined" /><span className="tooltiptext">Application Declined</span></>}
                  {application.ApplicationStatusId == 6 && <><img src="/images/Application-Withdrawn.png" alt="Withdrawn" /><span className="tooltiptext">Employer Withdrawn</span></>}
                </span>                
              </p>
            }
            <p>
              <label>Applicant First Name
                <input type="text" name="FirstName" value={application.FirstName} required maxLength={50} onChange={OnChange} />
              </label>
            </p>
            <p>
              <label>Applicant Last Name
                <input type="text" name="LastName" value={application.LastName} required maxLength={50} onChange={OnChange} />
              </label>
            </p>
            <p>
              <label>Job Title
                <input type="text" name="JobTitle" value={application.JobTitle} required maxLength={50} onChange={OnChange} />
              </label>
            </p>

            <h2>Documents</h2>
            <p><em>DOC and PDF file types accepted. 4MB max file size.</em></p>
            <DocumentComponent identifier="Upload0" label="Job Offer Form" application={application} propertyValue="JobOfferId" propertyName="Filename_JobOffer" SetApplication={SetApplication} />
            <DocumentComponent identifier="Upload1" label="Schedule 1" application={application} propertyValue="Schedule1Id" propertyName="Filename_Schedule1" SetApplication={SetApplication} />
            <DocumentComponent identifier="Upload2" label="Language Test Results" application={application} propertyValue="LanguageTestResultId" propertyName="Filename_LanguageTestResult" SetApplication={SetApplication} />
            <DocumentComponent identifier="Upload3" label="Passport Scan" application={application} propertyValue="PassportScanId" propertyName="Filename_PassportScan" SetApplication={SetApplication} />
            <DocumentComponent identifier="Upload4" label="Proof of Status (optional)" application={application} propertyValue="ProofOfStatusId" propertyName="Filename_ProofOfStatus" SetApplication={SetApplication} />
            <DocumentComponent identifier="Upload5" label="Proof of Work Experience" application={application} propertyValue="ProofOfWorkExperienceId" propertyName="Filename_ProofOfWorkExperience" SetApplication={SetApplication} />
            <DocumentComponent identifier="Upload6" label="Intent to Reside Declaration" application={application} propertyValue="IntentToResideId" propertyName="Filename_IntentToReside" SetApplication={SetApplication} />

            <h3>Education Documents</h3>
            <p><em>Note: only one education document is required</em></p>
            <DocumentComponent identifier="Upload7" label="Education Credential Assessment (ECA)" application={application} propertyValue="EducationCredentialId" propertyName="Filename_EducationCredential" SetApplication={SetApplication} />
            <DocumentComponent identifier="Upload8" label="Canadian Education Credential" application={application} propertyValue="CanadianCredentialId" propertyName="Filename_CanadianCredential" SetApplication={SetApplication} />

            <AdditionalDocumentComponent application={application} AddAdditionalDocument={AddAdditionalDocument} DeleteAdditionalDocument={DeleteAdditionalDocument} />

            <p className="formButton biggerSpace"><input type="submit" value={applicationId ? "Update Application" : "Create Application"} /></p>
          </form>
          
          {Number(applicationId) > 0 && <CommentComponent applicationId={Number(applicationId)} businessId={application.BusinessId} />}
        </div>
      </section>
    </>
  );
}

export default ApplicationView;